import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { formatDateSafe } from '../../../../../utilities/date';

const money = (v) => Number(v || 0).toLocaleString('es-PE', { style:'currency', currency:'PEN' });
const BAR_COLOR = '#dc2626';

function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  const value = payload[0]?.value ?? 0;

  return (
    <div className="rounded-2xl border border-gray-100 bg-white px-3 py-2 text-xs shadow-lg">
      <div className="text-gray-500">{formatDateSafe(label)}</div>
      <div className="mt-1 flex items-center gap-2 text-sm font-semibold text-gray-900">
        <span className="inline-block h-2 w-2 rounded-full bg-red-500" />
        {money(value)}
      </div>
    </div>
  );
}

export default function DailyBarChart({ data = [], title = 'Desembolso por fecha' }) {
  return (
    <div className="h-full">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <p className="text-xs text-gray-500">Crecimiento diario de desembolsos</p>
        </div>
      </div>

      <div className="h-[320px] overflow-visible">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 12, right: 16, left: 8, bottom: 12 }}
            barCategoryGap="12%"
          >
            <CartesianGrid stroke="#e2e8f0" strokeDasharray="4 4" vertical={false} />
            <XAxis
              dataKey="fecha"
              tickFormatter={(v) => formatDateSafe(v)}
              tick={{ fontSize: 11, fill: '#6b7280' }}
              interval="preserveStartEnd"
            />
            <YAxis tickFormatter={(v) => money(v)} tick={{ fontSize: 11, fill: '#6b7280' }} />
            <Tooltip content={<ChartTooltip />} />
            <Bar
              dataKey="value"
              name="Monto desembolsado"
              fill={BAR_COLOR}
              radius={[6, 6, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
